import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const isPremium: TComputedPropMapper<boolean> = ({ offer: { isPremium } }) => Boolean(isPremium);
